var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 35 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__a)",
    fillRule: "evenodd",
    d: "M17.074.558a3.7 3.7 0 0 0-2.546 1.027 3.414 3.414 0 0 0 0 4.958l9.744 9.38 2.29-2.205.062-.06a3.79 3.79 0 0 0-.061-5.447l-6.884-6.626-.062-.058a3.7 3.7 0 0 0-2.484-.97zM5.497 10.915 24.04 28.803l5.114-4.934L10.611 5.981zm-3.856 4.067-.06.059A3.37 3.37 0 0 0 .578 17.42v.022a3.37 3.37 0 0 0 1.063 2.438c1.418 1.352 3.717 1.352 5.134 0a3.35 3.35 0 0 0 0-4.898L4.21 12.534zm26.233-.305a3.35 3.35 0 0 0 0 4.898l2.568 2.449 2.567-2.45.06-.058a3.35 3.35 0 0 0-.06-4.839 3.71 3.71 0 0 0-2.567-1.014c-.93 0-1.859.338-2.568 1.014M8.084 21.07l-.062.061c-1.516 1.513-1.495 3.389.062 4.892l6.893 6.723.06.058c.7.644 1.6.968 2.501.97h.022a3.7 3.7 0 0 0 2.562-1.028 3.425 3.425 0 0 0 0-4.966l-9.75-8.919z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__a",
    x1: 24.463,
    x2: 7.54,
    y1: 6.719,
    y2: 26.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })))));
};
export { SvgLogo as ReactComponent };